import { DELETE, GET, PATCH, POST } from '../common/common.service'
import endpointsOwnFuelStations from './endpoints'

export const OwnFuelStationsService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsOwnFuelStations.LOAD(filter, sort, limit, skip)),
  create: async (body) => POST(endpointsOwnFuelStations.CREATE, body),
  getById: async (id) => GET(endpointsOwnFuelStations.BY_ID(id)),
  update: async ({ id, body }) =>
    PATCH(endpointsOwnFuelStations.BY_ID(id), body),
  remove: async (id) => DELETE(endpointsOwnFuelStations.BY_ID(id)),
}
